const getters = {
  token: state => state.account.token,
  userInfo: state => state.account.userInfo,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js